/* @flow strict */

import * as React from 'react';
import './styles.scss';

type PropsType = {
  name?: string,
  'aria-label'?: string,
  className?: string,
  wrapperClassName?: string,
  id: string | number,
  index: string | number,
  label?: any,
  checked?: boolean,
  onCallback?: (e: SyntheticEvent<HTMLInputElement>) => void,
  onClick?: () => void, // for forwardRef used
  refff?: any,
  disabled?: boolean,
  dataTestid?: string
};

const Switcher = (props: PropsType): React.Element<typeof React.Fragment> => {
  const [checked, handleChecked] = React.useState(props.checked);

  React.useEffect(() => {
    handleChecked(props.checked);
  }, [props.checked]);

  const _handleChecked = (e: SyntheticEvent<HTMLInputElement>) => {
    if (!props.disabled) {
      const newStatus = !checked;

      handleChecked(newStatus);

      if (props.onCallback) {
        props.onCallback(e, newStatus);
      }
    }
  };

  return (
    <div style={{ whiteSpace: 'nowrap' }} className={props.wrapperClassName ? props.wrapperClassName : ''}>
      <div className={`form-switcher ${props.className} ${props.disabled ? 'disabled' : ''}`}>
        <input
          ref={props.refff}
          type="checkbox"
          id={props.id}
          data-index={props.index}
          checked={props.refff ? props.checked : checked}
          onChange={props.refff ? props.onClick : _handleChecked}
          name={props.name || props.id}
          aria-label={props['aria-label']}
          data-testid={!!props.dataTestid ? props.dataTestid : 'Switcher'}
        />
        <label className="switcher" htmlFor={props.id}  />
      </div>
      {props.label ?
        <label
          htmlFor={props.id}
          style={{
            whiteSpace: 'normal',
            display: 'block'
          }}
        >
          {props.label}
        </label> :
        null
      }
    </div>
  );
};

export default Switcher;
